import { render, staticRenderFns } from "./ProductTypeForm.vue?vue&type=template&id=3033cad7"
import script from "./ProductTypeForm.vue?vue&type=script&lang=js"
export * from "./ProductTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports